import React from "react";
import "./FixedLogo.css"; // Import the CSS file for styling

const FixedLogo = () => {
  // WhatsApp URL (you can customize this to include a pre-filled message or phone number)
  const whatsappUrl = "https://chat.whatsapp.com/KqeGz58KHTJ1NfrnT5WkeX"; // Replace with your desired WhatsApp link

  return (
    <div className="fixed-logo">
      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Direct link to WhatsApp logo
          alt="WhatsApp Logo"
          className="logo-img"
        />
      </a>
    </div>
  );
};

export default FixedLogo;